import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild, AfterViewInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { Chart, ChartType, registerables } from 'chart.js';
import { pTicket } from '../../../interfaces/pTicket';
import { PTicketService } from '../../../services/p-ticket.service';
import { report } from '../../../interfaces/preport';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { EventEmitter } from 'stream';
import { Subscription } from 'rxjs';

Chart.register(...registerables);

interface dataset {
  label: string[];
  data: number[];
}

@Component({
  selector: 'app-reporting-graph',
  standalone: true,
  imports: [FormsModule, NgIf, MatProgressSpinnerModule, MatButtonModule],
  templateUrl: './reporting-graph.component.html',
  styleUrls: ['./reporting-graph.component.scss']
})
export class ReportingGraphComponent {
  @Input() report!: report;
  private subscription!: Subscription;
  @ViewChild('chartCanvas', { static: true }) chartCanvas!: ElementRef<HTMLCanvasElement>;

  ptickets: pTicket[] = [];
  chart!: Chart;
  isLoading: boolean = false;

  selectedXAxis: keyof pTicket = 'pct_has_solution';
  chartType: ChartType = 'bar';
  dataset: dataset = { label: [], data: [] };

  readonly defaultColors = [
    '#1f77b4',
    '#ff7f0e',
    '#2ca02c',
    '#d62728',
    '#9467bd',
    '#8c564b',
    '#e377c2',
    '#7f7f7f',
    '#bcbd22',
    '#17becf',
    '#393b79',
    '#637939',
    '#8c6d31',
    '#843c39',
    '#7b4173',
    '#5254a3',
    '#9c9ede',
    '#cedb9c',
    '#f7b6d2',
    '#c7c7c7'
  ]

  data = {
    labels: this.dataset.label,
    datasets: [{
      label: 'Result',
      data: this.dataset.data,
      backgroundColor: this.defaultColors
    }]
  };

  constructor(private pTicketService: PTicketService,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (this.report) {
      this.loadTickets(this.report);
    }
  }



  graphUpdate(event: Event): void {
  }

  loadTickets(report: report): void {
    this.isLoading = true;
    this.cdRef.detectChanges();
    if (this.chart) this.chart.destroy();

    this.pTicketService.getAll(report.rep_filter).subscribe(tickets => {
      this.ptickets = tickets;
      this.isLoading = false;
      this.cdRef.detectChanges();

      this.selectedXAxis = report.rep_xAxisOption.key;
      this.chartType = report.rep_chartType;

      const grouped = new Map<string, number>();

      for (const t of this.ptickets) {
        let keys: string[] = [];

        // Handle keywords differently
        if (this.selectedXAxis === 'pkeywords') {
          // Map keyword objects to string values
          keys = t.pkeywords?.map(k => k.pkw_value) || ['Unknown'];
        } else {
          keys = [String(t[this.selectedXAxis] ?? 'Unknown')];
        }

        // Count each key
        for (const key of keys) {
          let k = key;
          if (k.includes('default_')) {
            k = 'unknown';
          }
          grouped.set(k, (grouped.get(k) || 0) + 1);
        }
      }

      this.dataset = {
        label: Array.from(grouped.keys()).map(key => `${key} (${grouped.get(key)})`),
        data: Array.from(grouped.values())
      };

      this.data = {
        labels: this.dataset.label,
        datasets: [{
          ...this.data.datasets[0],
          data: this.dataset.data
        }]
      };

      this.createChart();
    });
  }

  createChart(): void {
    if (!this.chartCanvas) return;
    if (this.chart) this.chart.destroy();


    // big charts | doughnut, pie and radar
    if (this.chartType == "pie" || this.chartType == "doughnut" || this.chartType == "radar") {
      this.chart = new Chart(this.chartCanvas.nativeElement, {
        type: this.chartType,
        data: this.data,

        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
          }
        }
      });
    }
    else {
      this.chart = new Chart(this.chartCanvas.nativeElement, {
      type: this.chartType,
      data: this.data,

      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true
          },
          x: {
            beginAtZero: true,
            ticks: {
              autoSkip: false
            }
          }
        }
      }
    });
    }

    
    
  }

  onTypeChange(newType: ChartType) {
    this.chartType = newType;
    this.createChart();
  }
}
